import { defineStore } from 'pinia';

import {
  WalletServiceSettingRepository,
  WalletServiceSettingResponse,
} from '@/repositories/generated';

type WalletServiceSettingStoreState = Partial<WalletServiceSettingResponse>;

export const useWalletServiceSettingStore = defineStore('walletServiceSetting', {
  state: (): WalletServiceSettingStoreState => ({
    prepaidSettlementDisplayType: undefined,
    walletServiceSettingList: undefined,
  }),
  actions: {
    async getWalletServiceSetting(walletServiceIds: string[]) {
      const res = await WalletServiceSettingRepository.walletServiceSetting({
        walletServiceIds,
      });
      this.prepaidSettlementDisplayType = res.prepaidSettlementDisplayType;
      this.walletServiceSettingList = res.walletServiceSettingList;
      return res;
    },
  },
});

export default useWalletServiceSettingStore;
